import React from 'react';
import PropTypes from 'prop-types';

import StepperInner from '@common/components/Stepper';

import { useMultiStepContext } from './multiStepContext';

const Stepper = ({ steps }) => {
  const { currentStep, handleChangeStep, reachedSteps, stepsValidity } =
    useMultiStepContext();

  const stepsWithStates = steps.map((title, index) => ({
    title,
    isActive: index === currentStep,
    onClick: () => handleChangeStep(index),
    isClickable: !!(
      index < currentStep ||
      (reachedSteps[index] && stepsValidity.slice(0, index).every(item => item))
    ),
  }));

  return <StepperInner steps={stepsWithStates} />;
};

Stepper.propTypes = {
  steps: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default Stepper;
